import { getDefaultStore } from 'jotai/vanilla';

import { currentOrganizationSyncAtom } from '@cast/infrastructure-organization';
import { initSentry } from '@cast/infrastructure-monitoring';

import { IS_PROD } from '@oneclick/constants/constants';

initSentry({
  isProd: IS_PROD,
  getOrganization: () => getDefaultStore().get(currentOrganizationSyncAtom),
});
